/**
 * A La Mode is a small accessibility compliant modal leveraging the HTML dialog element
 * This is a bootstrap file to include to your project entry point, that will create a modal instance
 * for all dialog with the data-a-la-mode-id attribute
 *
 * Specified and tested by Magnetic
 * Assisted-by: ChatGPT
 */
import {almModalManager} from "./AlmModalManager";
import AlmModal from './AlmModal';
import './_aLaMode.scss';

console.log('aLaModeManager created', almModalManager);
window.aLaModeManager = almModalManager;
document.querySelectorAll('dialog[data-a-la-mode-id]').forEach(dialog => {
    const id = dialog.dataset.aLaModeId;

    const modal = new AlmModal(dialog, id);

    almModalManager.register(id, modal);
});
